import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

/**
 * DevicePlatform provides enumerated values about which platform we are
 * running on to enable special bridging when in a native app.
 *
 * @enum {number}
 * @readonly
 */
export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'iOS' },
    { value: 2, label: 'Android' },
    { value: 3, label: 'Android TWA' },
  ],
});
